// extracted by mini-css-extract-plugin
export default {"root":"root_root__w65Z5"};